import dashboardColumns from '@/src/models/dashboard/dashboardColumns.json'
export interface DashboardColumn {
  id: string;
  service_level_override: string;
  final_disposition_override_id: string;
  final_disposition_notes_override: string;
  auto_rule_out: boolean;
  physician: string;
  decline_note: string;
  case: boolean;
  non_recovery_id: string;
  first_transplant_date: string;
  second_transplant_date: string;
  first_organ_non_recovery: string;
  second_organ_non_recovery: string;
}
export class QADashboard {
  static DASHBOARD_COLUMNS = dashboardColumns;

  id: string;
  service_level_override: string;
  final_disposition_override_id: string;
  final_disposition_notes_override: string;
  auto_rule_out: boolean;
  physician: string;
  decline_note: string;
  case: boolean;
  non_recovery_id: string;
  first_transplant_date: string;
  second_transplant_date: string;
  first_organ_non_recovery: string;
  second_organ_non_recovery: string;
  
  constructor(data ) {
    this.id = data.id;
    this.service_level_override = data.service_level_override;
    this.final_disposition_override_id = data.calculated_stats.final_disposition_override?.id;
    this.final_disposition_notes_override = data.calculated_stats.final_disposition_notes_override;
    this.auto_rule_out = data.auto_rule_out;
    this.physician = data.physician;
    this.decline_note = data.decline_note;
    this.case = data.case;
    this.non_recovery_id = data.donor.non_recovery_id;
    this.first_transplant_date = data.first_accepted_transplant_details?.transplant_date?.display;
    this.second_transplant_date = data.second_accepted_transplant_details?.transplant_date?.display;
    this.first_organ_non_recovery = data.first_accepted_transplant_details?.organ_non_recovery;
    this.second_organ_non_recovery = data.second_accepted_transplant_details?.organ_non_recovery;
  }

  payloadForApi() {
    const payload = {
      id: this.id,
      service_level_override: this.service_level_override,
      final_disposition_override_id: this.final_disposition_override_id,
      final_disposition_notes_override: this.final_disposition_notes_override,
      auto_rule_out: this.auto_rule_out,
      physician: this.physician,
      decline_note: this.decline_note,
      case: this.case || false,
      non_recovery_id: this.non_recovery_id,
      first_transplant_date: this.first_transplant_date,
      second_transplant_date: this.second_transplant_date,
      first_organ_non_recovery: this.first_organ_non_recovery,
      second_organ_non_recovery: this.second_organ_non_recovery
    }

    return Object.fromEntries(
     Object.entries(payload).filter(
      ([_adapters, value]) =>
        value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '')
      )
    );
  }
  

}

